import { defineComponent } from 'vue';
import { inlineLightbox } from '/src/ts/modules/lightbox.ts';

export default defineComponent({
  delimiters: ['${', '}'],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    orderHistory() {
      return this.$store.getters.orderHistory;
    },
  },
  watch: {
    orderHistory() {
      this.loading = false;
      /**
       * Here was call re-initialise an inline lightbox instance again
       * Otherwise, this button markup loads too slow and the initialise
       * step in the entry point is fired before this has rendered.
       */
      inlineLightbox();
    },
  },
  mounted() {
    if (this.orderHistory.length) {
      this.loading = false;
    }
  },
  template: '#t-customer-previous-order',
});
